<template>
  <div class="navbar">
    <nav class="nav-center custom-nav fixed-top navbar-expand-lg navbar-light bg-light">
      <div class="nav-header navbar my-auto">
        <router-link to="/">
          <img src="@/assets/logo.png" alt="homedinamics logo" />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav my-auto mr-auto">
            <li class="nav-links show-nav">
              <router-link to="/" class="nav-link">Inicio</router-link>
            </li>
            <li class="nav-links show-nav">
              <router-link to="/productos" class="nav-link" href="#">Productos</router-link>
            </li>

            <li class="nav-links show-nav">
              <router-link to="/lineas" class="nav-link" href="#">Catálogos</router-link>
            </li>
          </ul>
          <form class="form-inline my-2 my-lg-0 my-auto">
            <!-- <input class="form-control mr-sm-2" type="search" placeholder="Led-House img" aria-label="Search"> -->
            <a
              class="btn mx-2 my-2 my-sm-0"
              style="font-size: 1.8em; color: Dodgerblue;"
              data-toggle="modal"
              data-target="#miniCart"
            >
              <i class="fas fa-edit"></i>
            </a>
          </form>
          <img class="mr-sm-3 my-auto" src="@/assets/logo-led.png" alt="ledhouse logo" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    msg: String
  },
  components: {},
  data() {
    return {
      ruta: this.$route.name
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/*  @media (min-width: 992px) { 
    
    .navbar.custom-nav{
      padding-top:16px;
      padding-bottom:16px;
      background-color: #fff !important;
    }

   } */

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0.75rem 2rem;
  background: var(--mainWhite);
  z-index: 1;
  box-shadow: 2px 2px 10px #666;
}
.nav-header {
  display: flex;
  justify-content: space-between;
}
.nav-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
}
.nav-icon {
  font-size: 1.5rem;
  color: var(--primaryColor);
}
.nav-links {
  height: 0;
  overflow: hidden;
  transition: var(--mainTransition);
  list-style-type: none;
}
.nav-links router-link {
  display: block;
  text-decoration: none;
  padding: 1rem 0;
  color: var(--mainWhite);
  transition: var(--mainTransition);
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: var(--mainSpacing);
}
.nav-links router-link:hover {
  color: var(--primaryColor);
}

.show-nav {
  height: 45px;
}
@media screen and (min-width: 768px) {
  .nav-btn {
    display: none;
  }
  .nav-center {
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
  }
  .nav-links {
    height: auto;
    display: flex;
    margin-left: 4rem;
  }
  .nav-links router-link {
    margin: 0 1rem;
    padding: 0.5rem 0;
  }
}
</style>
